<template>
    <a-modal
      title="预报名(定时自动创建报名待支付订单)"
      :maskClosable="false"
      :width="1200"
      :visible="visible"
      :confirmLoading="confirmLoading"
      :cancelText="'取消'"
      :okText="'确定'"
      @cancel="handleCancel"
      @ok="handleSubmit"
      :destroyOnClose="true"
    >
    <div class="class-list">
<div class="first-row">
        <a-form-item label="学期" class="school-item">
            <a-select
              class="form-cell"
              placeholder="请选择"
              v-model="queryParam.termId"
              style="width:300px"
              @change="handleClassSearch('')"
            >
              <a-select-option
                v-for="(item, index) in termList"
                :key="index"
                :value="item.id"
                >{{ item.termName}}</a-select-option
              >
            </a-select>
          </a-form-item>

          <a-form-item label="已报名班级" class="name">
            <a-select
              class="form-cell"
              :show-search="true"
              placeholder="请选择，输入名称筛选"
              :not-found-content="null"
              filterOption
              v-model="queryParam.studentClassId"
              optionFilterProp="children"
              @search="handleClassSearch"
              :default-active-first-option="false"
              style="width:300px"
            >
              <a-select-option
                v-for="(item, index) in classList"
                :key="index"
                :value="item.id"
                >{{ "("+item.id+")"+item.className }}</a-select-option
              >
            </a-select>
            <!-- <a-input
              class="form-cell"
              type="text"
              placeholder="请输入"
              v-model="queryParam.courseId"
              @change="inputChange"
              @blur="inputBlur"
            ></a-input> -->
          </a-form-item>

</div>
<div class="second-row">
    <a-form-item class="name" label="学生名称">
            <a-input
              class="form-cell"
              type="text"
              placeholder="请输入"
              v-model="queryParam.studentName"
            ></a-input>
          </a-form-item>

          <a-form-item class="name" label="学号">
            <a-input
              class="form-cell"
              type="text"
              placeholder="请输入"
              v-model="queryParam.studentNumber"
            ></a-input>
          </a-form-item>
</div>

<div class="third-row">
    <a-form-item class="name" label="年级">
            <a-select
              class="form-cell"
              placeholder="请选择"
              v-model="queryParam.gradeId"
              @change="searchOriginalClass"
            >
              <a-select-option
                v-for="(item, index) in schoolGrade"
                :key="index"
                :value="item.gradeTagId"
                >{{ item.gradeName }}</a-select-option
              >
            </a-select>
          </a-form-item>
          <a-form-item label="原始班级" class="name">
            <a-select
              class="form-cell"
              placeholder="请选择"
              v-model="queryParam.classId"
            >
              <a-select-option
                v-for="(item, index) in originalClassList"
                :key="index"
                :value="item.id"
                >{{ item.className }}</a-select-option
              >
            </a-select>
          </a-form-item>
          <a-form-item class="search-oper">
            <a-button class="search" type="primary" @click="searchStudent()"
              >查询</a-button
            >
            <a-button type="primary" @click="resetForm">重置</a-button>
          </a-form-item>
</div>
      <!-- 表格数据 -->
      <a-table rowKey="id"
        :columns="columns"
        :dataSource="studentList"
        :pagination="pagination"
        :loading="loading"
        @change="tableChange"
        :row-selection="{ selectedRowKeys: selectedStudent, onChange: onSelectChange }"
      >
        <span slot="gradeId" slot-scope="text, record">
          <template>
            <span>{{ record.gradeId | gradeScopeFilter }}</span>
          </template>
        </span>
        <span slot="gender" slot-scope="text, record">
          <template>
            <span>{{ record.gender | gender }}</span>
          </template>
        </span>
      </a-table>
    </div>
      <a-modal
        :closable="false"
        title="未查询到的学生或学号"
        :maskClosable="false"
        :width="400"
        :visible="barrenVisible"
        :confirmLoading="confirmLoading"
      >
        <template slot="footer">
          <a-button type="primary" key="back" @click="barrenVisible = false">
            确定
          </a-button>
        </template>
        <span v-for="(item, index) in barrenList" :key="index">{{ item }}</span>
      </a-modal>
      <div class="establish-time">
            <!-- :ranges="ranges" 
            :defaultPickerValue="[moment('00:00', 'HH:mm'), moment('00:00', 'HH:mm')]"label="订单付款开始截止时间" layout="inline" 
            -->
        <a-form-item :required="true">
          <template v-if="hasSelected">{{  `已选择学生数:${selectedStudent.length}&nbsp;&nbsp;`  }}</template>
          <a-range-picker
            :value="times"
            format="YYYY-MM-DD HH:mm:00"
            @change="onTimeChange"
            :showTime="{ format: 'HH:mm'}"
            :disabledDate="disabledDate"
            :placeholder="['订单付款开始时间','订单付款截止时间']"
            style="width:450px;"
          />
        </a-form-item>
      </div>
    </a-modal>
  </template>
  
  <script>
  import student from '../../../api/student'
  
  import classSet from '../../../api/classSet'
  
  import sourceClass from '../../../api/sourceClass'
  
  import moment from 'moment'

  import Vue from 'vue'

  import course from '../../../api/course'

import term from '../../../api/term'

import { toNumber } from 'lodash'
import { nextTick } from 'process'
  
  const columns = [
    {
      title: '学生ID',
      dataIndex: 'id',
      key: "id",
      width: 90,
    },
    {
      title: '学生名称',
      dataIndex: 'studentName',
      key: "studentName",
      width: 90,
    },
    {
      title: '性别',
      dataIndex: 'gender',
      scopedSlots: { customRender: 'gender' },
      width: 50,
    },
    {
      title: '生日',
      dataIndex: 'birthday',
      width: 100,
    },
    {
      title: '学号',
      dataIndex: 'studentNumber',
    },
    {
      title: '年级',
      dataIndex: 'gradeId',
      scopedSlots: { customRender: 'gradeId' },
      width: 80,
    },
    {
      title: '原始班级',
      dataIndex: 'className',
    },
    {
      title: '创建时间',
      dataIndex: 'gmtCreate',
      sorter: (a, b) =>
        new Date(a.gmtCreate).getTime() - new Date(b.gmtCreate).getTime(),
        width: 170,
    },
  ]
  export default {
    name: 'NewForecastProject',
    props:['originalClass'],
    data() {
      return {
        moment,
        columns, //列标识数据
        visible: false,
        confirmLoading: false,
        studentList: [], //学生列表
        selectedStudent: [], //选中的行
        classId: '', //班级ID
        times: [],
        pagination: {
          showTotal: (total) => `总共 ${total} 条`, // 显示总数
          current: 1,
          pageSize: 100,
          total: 0,
          pageSizeOptions: ['10', '20', '30', '50', '70', '100'],
          showLessItems: true,
          showSizeChanger: true,
        }, //分页数据对象
        loading: true,
        queryParam: {}, //查询参数
        originalClassList: [], //班级列表
        originalClassListAll: null,
        barrenVisible: false, //批量插班，弹框
        barrenList: [],
        school: Vue.ls.get('schoolId'),
        termList:Vue.ls.get("term"),
        classList: [], //这里的课程列表是错误的。应该是课后服务班级列表courseList: [],
        items:{},
        searchValue:'',
        schoolGrade: Vue.ls.get("schoolGrade")
      }
    },
    computed: {
      hasSelected() {
        return this.selectedStudent.length > 0;
      },
    },
    mounted(){
        console.log(this.originalClass,'orginalClassorginalClassorginalClass')
      },
    methods: {
      resetForm(){
        this.queryParam = {};
        this.originalClassList=this.originalClassListAll;
      },
      //table发生该表，分页，排序
      tableChange(pagination, filters, sorter) {
        //如果查询有地址的话，把地址解析之后带入
        let obj = this.queryParam
        obj.currentPage = pagination.current
        obj.pageSize = pagination.pageSize
        this.pagination.current = pagination.current
        this.pagination.pageSize = pagination.pageSize
        //存在排序的时候
        if (sorter && sorter.columnKey) {
          obj.sorter = `${sorter.columnKey}-${
            sorter.order == 'ascend' ? 'asc' : 'desc'
          }`
        }
        this.getClassStudentList(obj)
      },
      onTimeChange(date) {
      this.times = date
      if (!date.length) {
        this.items = {}
        return
      }
      this.items.startTime = moment(date[0]).format('YYYY-MM-DD HH:mm:ss')
      this.items.endTime = moment(date[1]).format('YYYY-MM-DD HH:mm:ss')
      console.log(this.items.startTime,this.items.endTime,'date的数据是什么')
    },
    Timechange(){
      console.log('时间改变进入了吗')
    },
    getDisabledMinutes (selectedHour) {
      console.log('禁止分钟改变进入了吗')
      let time = this.items.endTime
      let timeArr = time.split(':')
      let minutes = []
      if (selectedHour == parseInt(timeArr[0])) {
        for(var i = 0; i < parseInt(timeArr[1]); i++) {
          minutes.push(i)
        }
      }
      return minutes
    },
      //提交
      handleSubmit() {
        if (this.selectedStudent.length == 0) {
          this.$message.warn('请选择学生')
          return
        }
        if(!this.items.startTime || !this.items.endTime) {
          this.$message.warn('请选择订单付款开始截止时间时间')
          return
        }
        if(this.items.startTime >= this.items.endTime) {
          this.$message.warn('结束时间必须要大于开始时间')
          return
        }
        let req = {
          classId: this.classId.id,
          courseId: this.classId.courseId,
          studentIds: this.selectedStudent.join(),
          startTime: this.items.startTime,
          endTime: this.items.endTime,
        }
        classSet.preEnroll(req).then((res) => {
          this.$message.success('新建预报名成功')
          this.$emit('refreshList', res.data)
          this.handleCancel()
          this.selectedStudent = [];
          this.times = [];
          this.items = {};
          console.log('preEnroll complete',this.selectedStudent)
          this.$emit('freshen','我是通过子组件传递过来的')
          this.pagination.current = 1
        })
      },
      handleClassSearch(value){
        classSet.getClassList({className:value,termId:this.queryParam.termId,schoolId:this.$store.getters.schoolId}).then((res)=>{
          this.classList = res.data.list
        })
      },
      //table选中事件
      onSelectChange(selectedRowKeys, value) {
        this.selectedStudent = selectedRowKeys;
        // value.map((item) => {
        //   this.selectedStudent.push(item.id)
        // })
      },
      range (start, end)  {
    const result = [];
    for (let i = start; i < end; i++) {
        result.push(i);
    }
    return result;
    },
      disabledDateTwo(dates,partial){
        let _this = this;
        let nowHour = new Date().getHours()
      let nowMinutes = new Date().getMinutes()
      if(partial=='start'){
        return {
        disabledHours: () => this.range(0, nowHour),
        disabledMinutes: (() => {
          if(nowHour < (_this.items.startTime ? _this.items.startTime.substr(10,3):'') || nowHour < (_this.items.endTime ? _this.items.endTime.substr(10,3):'')){
           return _this.range(0, 0)
          } else{
            return _this.range(0, nowMinutes)
          }
        }),
        disabledSeconds: () => [0, 60],
      }
      }
      },
      disabledDate(current){
        return current && current < moment().subtract(1, 'days').endOf('day')
      },
      //初始化，显示
      init(id) {
        this.visible = true
        this.classId = id
        this.queryParam = {};
        this.getClassStudentList()
        // //下拉班级列表
        // student.getPreRegistrationList().then((res) => {
        //   // this.classList = res.data
        // })
        this.searchOriginalClass();
      },

      //隐藏
      handleCancel() {
        this.pagination.pageSize = 100
        this.visible = false
        this.$emit('closeForm')
        this.selectedStudent = [];
        this.pagination.current = 1
        this.times = [];
        this.items = {};
        this.originalClassListAll = null;
        console.log(this.items.startTime,'handleCancel')
      },
      gradeChange(value) {
        this.queryParam.gradeId = value;
        this.searchOriginalClass();
      },
      async searchOriginalClass(){
        var query = {schoolId:this.school};
        if (this.queryParam.gradeId) {
          query.gradeId = this.queryParam.gradeId;
        }
        const result = await sourceClass.getOriginalClassList(
          query
        )
        this.originalClassList = result.data.list
        if (this.originalClassListAll==null) {
          this.originalClassListAll = this.originalClassList
        }
      },
      //查询学生
      searchStudent() {
        // if (
        //   this.queryParam.studentId &&
        //   !/^[0-9]*$/.test(this.queryParam.studentId)
        // ) {
        //   this.$message.error('ID仅限输入数字')
        //   return
        // }
        this.getClassStudentList(this.queryParam)
      },
  
      //获取班级列表
      getClassStudentList(req = {}) {
        if (this.$store.getters.schoolId) {
          req.schoolId = this.$store.getters.schoolId
        }
        req.currentPage = this.pagination.current
        req.pageSize = this.pagination.pageSize
        this.loading = true
        console.log('req', req)
        student
          .getStudentList({
            ...req,
            // studentName: studentName.trim(),
            // ...this.pagination,
          })
          .then((res) => {
            console.log('res', res)
            if (res.data.noSearchStudentNameOrNumber) {
              this.barrenVisible = true
              this.barrenList = res.data.noSearchStudentNameOrNumber
            }
            this.studentList = res.data.list
            this.loading = false
            //分页信息
            // this.pagination = res.data.pagination;
            const total = res.data.pagination.total
            this.pagination.total = total
            if (
              total > 10000 &&
              !this.pagination.pageSizeOptions.includes('120')
            ) {
              this.pagination.pageSizeOptions = [
                ...this.pagination.pageSizeOptions,
                '120',
                '150',
              ]
            }
            if (
              res.data.pagination.total > 100000 &&
              !this.pagination.pageSizeOptions.includes('200')
            ) {
              this.pagination.pageSizeOptions.push('200')
            }
          })
      },
    },
  }
  </script>
  <style lang="scss" scoped>
  @import 'src/config/var';
  .third-row,.first-row, .second-row{
    display: flex;
    align-items: center;
  }

  .first-row ::v-deep .ant-form-item{
    display: flex;
    margin: 0;
  }

  .second-row ::v-deep .ant-form-item{
    display: flex;
    margin: 0;
  }

  .third-row ::v-deep .ant-form-item{
    display: flex;
    margin: 0;
  }

  .school-item ::v-deep .ant-select-selection__placeholder{
    white-space: normal;
  }

  .school-item ::v-deep .ant-select-selection-selected-value{
    width: 150px;
    overflow: hidden;
    text-overflow:ellipsis;
  }

  .third-row ::v-deep .search{
    margin-right: 15px;
  }
  .school-item{
        display: flex;
        align-items: center;;
    }
    .text{
        margin-right: 15px;
    }
  .class-list{
    height: calc(100vh - 320px);
    overflow-y: auto;
    overflow-x: hidden;
  }  
  .establish-time{
    position: absolute;
    bottom: -17px;
    right: 150px;
    margin: auto;
  }

  .establish-time ::v-deep .ant-calendar-range.ant-calendar-time .ant-calendar-time-picker-select{
    display: none;
    height: 0;
  }
  </style>
  